import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {EventStoreService} from "../../../services/event/event.store.service";
import {EventListFilterComponent} from "../../components/event-list-filter/event-list-filter.component";

@Component({
  templateUrl: './events.component.html',
  imports: [
    TranslateModule,
    EventListFilterComponent
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsComponent {
  #eventsStore = inject(EventStoreService);

  futureEvents = this.#eventsStore.futureEvents;

}

